/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'

const $nsid = 'app.bsky.graph.getRelationships'

export { $nsid }

/** Enumerates public relationships between one account, and a list of other accounts. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    others: l.optional(
      l.array(l.string({ format: 'at-identifier' }), { maxLength: 30 }),
    ),
  }),
  l.jsonPayload({
    actor: l.optional(l.string({ format: 'did' })),
    relationships: l.array(
      l.typedUnion(
        [
          l.typedRef<GraphDefs.Relationship>(
            (() => GraphDefs.relationship) as any,
          ),
          l.typedRef<GraphDefs.NotFoundActor>(
            (() => GraphDefs.notFoundActor) as any,
          ),
        ],
        false,
      ),
    ),
  }),
  ['ActorNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
